import { ContactInput } from 'sr-types/lib/production/v1/graphql';

/**
 * Apollo will validate the input shape against ContactInput.
 * Some UI flows (DataGrid row reconstruction) can add extra keys like resourceType/resourceSubType/resourceLabel.
 * This helper strips those out safely.
 */
export function toContactInputSafe(raw: any): ContactInput {
    if (!raw || typeof raw !== 'object') return {};
    const { resourceType, resourceSubType, resourceLabel, isHired, hiringStatus, __typename, ...rest } = raw;
    return rest as ContactInput;
}
